export function familyProgramsPath() {
  return '/family/programs'
}
